import React from "react";
import { oneOf, string } from "prop-types";

import Icon from "../../icons";

import "./social-auth-button.m.css";

const SocialAuthButton = ({ type, className, href }) => {
  return (
    <a
      aria-label={type === "fb" ? "FACEBOOK Button" : "GOOGLE Button"}
      styleName={`${type}-wrapper`}
      className={className}
      href={href}
    >
      <Icon
        type={type === "fb" ? "fb-blue" : "google-g"}
        width="42px"
        height="42px"
        styleName={type === "fb" ? "fb-blue" : "google-icon"}
      />
      <div styleName="title-wrapper">
        <span styleName="title">{`Sign in with ${type === "fb" ? "Facebook" : "Google"}`}</span>
      </div>
    </a>
  );
};

SocialAuthButton.propTypes = {
  href: string,
  type: oneOf(["google", "fb"]),
  className: string,
};

export default SocialAuthButton;
